<template>
  <div class="page-container">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <div class="top-layout">
        <div class="left-panel">
          <!-- 左侧表单内容：卡源、资费类型、总流量... -->
          <el-form-item label="卡源" prop="channel">
            <el-select v-model="propsParams.channel" placeholder="请选择卡源" @change="handleSelectChannel">
              <el-option
                v-for="item in channels"
                :key="item.channel"
                :label="item.name"
                :value="item.channel"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资费类型" prop="productType">
            <el-select v-model="propsParams.productType" placeholder="请选择资费类型">
              <el-option
                v-for="item in optType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外部套餐ID" prop="externalProductId" v-if="propsParams.channel == 'cmlink' && propsParams.productType == '2'">
            <el-select v-model="propsParams.externalProductId" filterable clearable placeholder="请选择外部套餐ID">
              <el-option
                v-for="item in productExternalData"
                :key="item.productId"
                :label="item.name + '[' + item.productId + ']'"
                :value="item.productId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资费名" prop="productName">
            <el-input v-model="propsParams.productName" placeholder="资费"></el-input>
          </el-form-item>
          <el-form-item label="总流量" prop="flowCount">
            <el-input placeholder="请输入总流量单位MB" v-model="propsParams.flowCount">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
          <el-form-item label="展示总流量" prop="showFlowCount">
            <el-input placeholder="请输入展示总流量单位MB" v-model="propsParams.showFlowCount">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
          <el-form-item label="有效期" prop="validityTime">
            <el-input placeholder="有效期，30天为一月" v-model="propsParams.validityTime">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          
        </div>
        <div class="right-panel">
          <!-- 右侧表单内容：外部套餐ID、资费名、展示总流量... -->
          <el-form-item label="市场价格" prop="showPrice">
            <el-input placeholder="市场价格" v-model="propsParams.showPrice" >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="资费" prop="flowInfo">
            <el-checkbox-group v-model="propsParams.flowInfo">
              <el-checkbox v-for="item in flowInfos" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="描述信息" prop="remark" >
            <el-input
              style="width:355px;"
              type="textarea"
              :rows="3"
              placeholder="请输入列表描述信息"
              v-model="propsParams.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态设置" prop="status">
            <div style="display: flex; gap: 40px; align-items: center;">
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">是否启用</span>
                <el-switch v-model="propsParams.status" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch>
              </div>
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">国际站展示</span>
                <el-switch v-model="propsParams.website" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="语音" prop="voiceTotal">
            <el-input v-model="propsParams.voiceTotal" >
                <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
          <el-form-item label="短信(MO)" prop="smsMo">
            <el-input v-model="propsParams.smsMo" >
                <template slot="append">条</template>
            </el-input>
          </el-form-item>
          <el-form-item label="短信(MT)" prop="smsMt">
            <el-input v-model="propsParams.smsMt" >
                <template slot="append">条</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <!-- 下半部分：国家表格区 -->
      <div class="bottom-layout" v-if="propsParams.website == 1">
        <el-form-item label="国际站价格" prop="internationalPrice">
          <template slot="label">
            <el-tooltip content="国际站价格用于国际站购买套餐的价格" placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>国际站价格</span>
            </el-tooltip>
          </template>
          <el-input v-model="internationalPrice" placeholder="人民币价格" style="width:130px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
          </el-input>
          <el-button type="primary" size="mini" @click="handleUpdateInternationalPrice()" style="margin-left: 10px">按汇率设置价格</el-button>
          <el-button type="success" size="mini" @click="handleSelectCountry()" style="margin-left: 10px">选择限制国家</el-button>
        </el-form-item>
        <div class="table-container">
          <el-table ref="currencyTable" :data="propsParams.countryPrices" row-key="id"  height="100%" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="name" label="限制国家" align="center" width="180"></el-table-column>
            <el-table-column prop="currency" label="支付货币" align="center" width="180">
              <template #default="{ row }">
                <el-select
                  v-model="row.currency"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择货币代码"
                  style="width: 140px"
                  @change="handleCurrencyChange(row)"
                >
                  <el-option
                    v-for="item in currencyList"
                    :key="item.id"
                    :label="item.name + '[' + item.currency + ']'"
                    :value="item.currency"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="exchangeRateCny" label="汇率" align="center" width="100"></el-table-column>
            <el-table-column prop="currencySymbol" label="货币符号" align="center" width="120"></el-table-column>
            <el-table-column prop="price" label="支付价格" align="center">
              <span  slot="header">
                  <el-tooltip content="比例代理商H5展示价格" placement="top">
                      <i class="el-icon-question"></i>
                  </el-tooltip>
                    支付价格
              </span>
              <template #default={row}>
                <el-input style="width: 170px;"  v-model="row.price"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                  <template slot="append">{{row.currencySymbol}}</template>
                  </el-input>
              </template>
            </el-table-column>
            
            <el-table-column label="操作" align="center">
              <template #default="{ row }">
                <template v-if="row.leaf" >
                  <i class="el-icon-remove-outline" @click="removeCurrencyRow('currencyTable',row)" style="font-size:25px;color: #ff4949"></i>
                </template>
                <template v-else>
                  <i class="el-icon-circle-plus-outline" @click="addCurrencyRow('currencyTable',row)" style="font-size:25px;color: #1890ff;"></i>
                  <i class="el-icon-remove-outline" @click="removeParentCurrencyRow(row)" style="font-size:25px;color: #ff4949;margin-left:10px"></i>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="submit-footer">
        <el-button class="submit-btn" type="primary"  @click="handleSubmit">提交</el-button>
      </div>
    </el-form>
    <el-dialog title="国际站设置价格" :visible.sync="nextOperatorOpen" width="1300px"  :modal-append-to-body="true">
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item prop="countryName">
          <el-input v-model="queryParams.countryName"  placeholder="区域名称" clearable style="width: 210px" @keyup.enter.native="search" />
        </el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form>
      <el-form>
        <el-form-item>
          <el-input v-model="basePrice"  placeholder="人民币价格" clearable style="width: 210px" @keyup.enter.native="search" />
          <el-button type="primary" size="mini" @click="handleBatchPrice" style="margin-left: 10px">按汇率设置价格</el-button>
        </el-form-item>
      </el-form>
      <div class="dialog-operator">
        <el-table ref="treeTable" :data="countryData" @selection-change="handleSelectionChange" :row-class-name="hideCheckbox" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="selection" align="center" width="60px"></el-table-column>
          <el-table-column prop="name" label="限制国家" align="center" width="180"></el-table-column>
          <el-table-column prop="currency" label="支付货币" align="center" width="180">
            <template #default="{ row }">
              <el-select
                v-model="row.currency"
                filterable
                allow-create
                default-first-option
                placeholder="请选择货币代码"
                style="width: 140px"
                @change="handleDialogCurrencyChange(row)"
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.id"
                  :label="item.name + '[' + item.currency + ']'"
                  :value="item.currency"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeRateCny" label="汇率" align="center" width="100"></el-table-column>
          <el-table-column prop="currencySymbol" label="货币符号" align="center" width="120"></el-table-column>
          <el-table-column prop="price" label="售价" align="center">
            <span  slot="header">
                <el-tooltip content="比例代理商H5展示价格" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                  支付售价
            </span>
            <template #default={row}>
              <el-input style="width: 170px;"  v-model="row.price"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="append">{{row.currencySymbol}}</template>
                </el-input>
            </template>
          </el-table-column>
          
          <!-- 新增操作列 -->
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <i v-if="!row.leaf" class="el-icon-circle-plus-outline" @click="addCurrencyRow('treeTable',row)" style="font-size:25px;color: #1890ff;"></i>
              <i v-if="row.leaf" class="el-icon-remove-outline" @click="removeCurrencyRow('treeTable',row)" style="font-size:25px;color: #ff4949;"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
			<div class="dialog-footer" slot="footer">
				<el-button @click="confirmCountry" type="primary" plain>确认添加</el-button>
			</div>
    </el-dialog>
  
  </div>
</template>
<script>
import { selectGroups , addInternationalProduct , productExternalList} from "@/api/international.js";
import { currencyList } from "@/api/config.js"
import { listChannel } from "@/api/api.js";
export default {
  name: "internationalProductAdd",
  data() {
    let validateOperator = (rule, value, callback) => {
      let scs = this.propsParams.countryPrices
      if(scs.length == 0){
        callback(new Error('请配置套餐售卖国家价格'));
      }else{
        callback();
      }
    }
    return {
      internationalPrice:"",
      propsParams: {
        type:"3",
        productType:1,
        status:1,
        website:'0',
        countryPrice:[],
        channel:'multi',
        countryPrices:[],
        flowInfo:[],
      },
      optType: [{ value: "累计套餐", key: 1 },{ value: "月套餐", key: 2 },{ value: "加油包", key: 3 }],
      optNetwork: [
        { value: 2, label: "2G" },
        { value: 3, label: "3G" },
        { value: 4, label: "4G" },
        { value: 5, label: "5G" }
      ],
      flowInfos: [
        {value: "1", label: "推荐"},
        {value: "7", label: "不限速"},
        {value: "8", label: "热卖"},
      ],
      channels:[],
      ruleValidate: {
        productName: [
          { required: true, message: "请输入资费名", trigger: "blur" },
          { min: 3,max: 100,message: "请输入3至100字母数字或汉字",trigger: "blur"},
        ],
        type: [
          { required: true, message: "请选择套餐分类", trigger: "blur" }
        ],
        operator:[{ validator: validateOperator, required: true, trigger: "blur" }],
        productType: [
          { required: true, message: "请选择资费类型", trigger: "blur" }
        ],
        flowRatio: [
          { required: true, message: "请输入流量比例", trigger: "blur" }
        ],
        flowCount: [
          { required: true, message: "请输入总流量", trigger: "blur" },
          { 
            pattern: /^[1-9]\d*(\.\d{1,2})?$|^0\.\d{1,2}$/,
            message: '请输入大于0的数字，最多保留两位小数',
            trigger: ['blur', 'change'] 
          }
        ],
        showFlowCount: [
          { required: true, message: "请输入展示总流量", trigger: "blur" },
          { 
            pattern: /^[1-9]\d*(\.\d{1,2})?$|^0\.\d{1,2}$/,
            message: '请输入大于0的数字，最多保留两位小数',
            trigger: ['blur', 'change'] 
          }
        ],
        validityTime: [
          { required: true, message: "请输入有效期", trigger: "blur" }
        ],
        floorPrice: [
          { required: true, message: "请输入价格", trigger: "blur" }
        ],
        showPrice: [
          { required: true, message: "请输入市场价格", trigger: "blur" }
        ],
        remark:[
          { required: true, message: "请输入描述信息", trigger: "blur" }
        ],
        externalProductId:[
          {required: true, message: "请选择运营商套餐", trigger: "blur"}
        ]
      },
      nextOperatorOpen:false,
      countryData:[],
      queryParams:{
        countryName:undefined
      },
      currencyList:[],
      multipleSelectionCountry:[],
      productExternalData:[],
      moreCountryOpen:false,
      basePrice:"",
    };
  },
  methods: {
    hideCheckbox({ row, rowIndex }) {
      // 根据条件决定是否隐藏复选框
      if (row.leaf) {
        return 'hide-checkbox';
      }
      return '';
    },
    initChannel(){
      let operatorId = '4'
      listChannel({operatorId}).then(res=>{
        this.channels = res.data.data
      })
    },
    //查找货币
    getCurrencyList(){
      currencyList().then(res=>{
        this.currencyList = res.data.data
      })
    },
    addCurrencyRow(ref,row) {
      if (!row.children) {
        this.$set(row, 'children', []);
      }
      const newRow = {
        id: `${row.id}_${row.children.length + 1}`,
        parentId: row.id,
        name: '',
        englishName: '',
        currency: '',
        currencySymbol: '',
        price: '',
        leaf : true  //标记为叶子节点
      };
      // 将新行添加到当前行的 children 数组中
      row.children.push(newRow);
      this.$nextTick(() => {
        this.$refs[ref].toggleRowExpansion(row, true);
      });
    },
    handleCurrencyChange(row){
      const selectedCurrency = this.currencyList.find(
        item => item.currency === row.currency
      );
      if (selectedCurrency) {
        row.currencySymbol = selectedCurrency.currencySymbol
        row.exchangeRateCny = selectedCurrency.exchangeRateCny
        const basePrice = Number(this.internationalPrice);
        if (!isNaN(basePrice) && basePrice > 0) {
          const exchangeRate = Number(row.exchangeRateCny);
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            const calculatedPrice = (basePrice * exchangeRate).toFixed(2);
            this.$set(row, 'price', calculatedPrice);
          }
        }
      }
    },
    handleDialogCurrencyChange(row){
      const selectedCurrency = this.currencyList.find(
        item => item.currency === row.currency
      );
      if (selectedCurrency) {
        row.currencySymbol = selectedCurrency.currencySymbol
        row.exchangeRateCny = selectedCurrency.exchangeRateCny
        const basePrice = Number(this.basePrice);
        if (!isNaN(basePrice) && basePrice > 0) {
          const exchangeRate = Number(row.exchangeRateCny);
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            const calculatedPrice = (basePrice * exchangeRate).toFixed(2);
            this.$set(row, 'price', calculatedPrice);
          }
        }
      }
    },
    removeCurrencyRow(type,row) {
      let data = type == 'treeTable'  ? this.countryData : this.propsParams.countryPrices
      const parentRow = data.find(item => item.id === row.parentId);
      if(parentRow  && parentRow.children){
        const childIndex = parentRow.children.findIndex(child => child.id === row.id);
        if(childIndex !== -1){
          parentRow.children.splice(childIndex, 1);
        }
      }
    },
    removeParentCurrencyRow(row){
      let data =  this.propsParams.countryPrices
      const parentIndex = data.findIndex(item => item.id === row.id);
      if(parentIndex !== -1){
        data.splice(parentIndex, 1);
      }
    },
    // 创建套餐
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          addInternationalProduct(params).then(res => {
            this.$message.success("添加套餐成功");
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push({ path: `/package/internationalProduct` });
          });
        }
      });
    },
    search(){
      this.selectCountry();
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    handleSelectChannel(channel){
      this.propsParams.countryPrices = []
    },
    //批量设置价格 根据费率
    handleBatchPrice(){
      let basePrice = this.basePrice
      if (isNaN(basePrice) || basePrice <= 0) {
        this.$message.warning("请输入有效的人民币价格");
        return;
      }

      const updateItemPrice = (item) => {
        const exchangeRate = Number(item.exchangeRateCny);
        // 检查汇率是否有效，有效则更新价格
        if (!isNaN(exchangeRate) && exchangeRate > 0) {
          const calculatedPrice = (basePrice * exchangeRate).toFixed(2);
          this.$set(item, 'price', calculatedPrice);
        }
        // 如果有子节点，递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => updateItemPrice(child));
        }
      };
      // 遍历顶层节点并递归处理
      this.countryData.forEach(item => {
        updateItemPrice(item);
      });
      
    },
    handleUpdateInternationalPrice(){
      let price = this.internationalPrice
      if (isNaN(price) || price <= 0) {
        this.$message.warning("请输入有效的人民币价格");
        return;
      }

      const updateItemPrice = (item) => {
        const exchangeRate = Number(item.exchangeRateCny);
        // 检查汇率是否有效，有效则更新价格
        if (!isNaN(exchangeRate) && exchangeRate > 0) {
          const calculatedPrice = (price * exchangeRate).toFixed(2);
          this.$set(item, 'price', calculatedPrice);
        }
        // 如果有子节点，递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => updateItemPrice(child));
        }
      };
      // 遍历顶层节点并递归处理
      this.propsParams.countryPrices.forEach(item => {
        updateItemPrice(item);
      });
      
    },
    handleSelectCountry(){
      this.nextOperatorOpen = true
      this.selectCountry()
    },
    selectCountry(){
      let channel = this.propsParams.channel
      let name = this.queryParams.countryName
      let type = 'local';
      selectGroups({channel,name}).then(res=>{
        let  countryData = res.data.data
        countryData.forEach(item=>{
          item.price = 0
        })
        this.countryData = countryData
      })
    },
    selectProductExternalList(){
      let source = '2'
      productExternalList({source}).then(res=>{
        this.productExternalData = res.data.data
      })
    },
    handleSelectionChange(select){
      this.multipleSelectionCountry = select
    },
    deleteOperatorPrice(row){
      let services = this.propsParams.countryPrices;
      for (let i = services.length - 1; i >= 0; i--) {
        if(services[i].id === row.id){
          services.splice(i, 1);
        }
      }
    },
    confirmCountry(){
      this.nextOperatorOpen = false
      let scs = this.propsParams.countryPrices.map(m=>m.id)
      let countries = this.multipleSelectionCountry.filter(item=>scs.indexOf(item.id) == -1)
      this.propsParams.countryPrices.push(...countries)
    },
  },
  mounted() {

  },
  created() {
    this.selectProductExternalList()
    this.getCurrencyList()
    this.initChannel()
  }
};
</script>
<style scoped lang="less">
.page-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 90vh; /* 确保占满浏览器可视区域 */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  .top-layout {
    flex: 0 0 30%; 
    display: flex;
    overflow: hidden; 
    // border-bottom: 1px solid #eee; 
  }
  // 左侧部分
  .left-panel {
    width: 50%; /* 左右各占一半 */
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    // border-right: 1px solid #eee; 
  }
  //右侧部分
  .right-panel {
    width: 50%;
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
  }
  //下半部分
  .bottom-layout {
    //固定底部占 70% 高度
    flex: 0 0 70%;      
    padding: 20px;
    box-sizing: border-box;
    // padding-bottom: 80px;
  }
  .submit-footer {
    position: absolute;  
    bottom: 0;           
    left: 0;             
    width: 100%;         
    padding: 20px;       
    box-sizing: border-box; 
    z-index: 99;
  }

  .table-container {
    height: 230px; /* 减去表单元素高度（根据实际调整） */
    overflow: hidden;
  }
}

::v-deep .hide-checkbox .cell .el-checkbox__input {
  display: none !important;
}
.el-select {
  width: 350px;
  margin-left: 5px;
}
.el-input {
  width: 350px;
  margin-left: 5px;
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.cell button {
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.el-message-box__btns .el-button--small {
  width: 75px;
}
.dialog-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;

    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 60px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; 
  padding-top: 10px; 
  .custom-tag {
    margin: 0; 
  }
}
</style>
